module.exports = __webpack_public_path__ + "static/media/playstation.ab8a97fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/playstation.svg
// module id = 116
// module chunks = 0